import React, { useState } from 'react';

import { useParams } from "react-router-dom";
import { useList } from '../hooks/listHook';
import NotFound from '../useful/NotFound';
import { withAuthorization } from '../session';
import { useItem } from '../hooks/itemHook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag } from '@fortawesome/free-solid-svg-icons';

import TeamGeneral from './TeamGeneral';
import TeamLoader from '../loaders/TeamLoader';
import PlayerList from '../Players/PlayerList';
import ModalInfo from '../useful/ModalInfo';

const TeamPage = (props) => {

    const { tournament_uid, team_uid } = useParams(); // tournament and team uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { loading: loadingTeam, item: team } = useItem(props.firebase.teamDoc(userId, tournament_uid, team_uid), team_uid);
    const { loading: loadingPlayers, list: players } = useList(props.firebase.playerList(userId, tournament_uid, team_uid), team_uid);
    // const { loading: loadingPlayers, list: players } = { loading: false, list: [] }

    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    if (!loadingTeam && team == null) {
        return <NotFound />
    }

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const disabled = loadingTeam && loadingPlayers ? "disabled" : "";

    const teamLogo = (team && team.logoUrl) ? team.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"

    return (
        <div className="bg-white border rounded-lg">
            {!(loadingTeam) ?
                <div className="col  p-2 m-0 ">
                    <div className="row align-self-center mr-0 ml-0">
                        <div className="position-relative" >
                            <div style={{
                                backgroundImage: `url(${teamLogo})`,
                                height: 48,
                                width: 48,
                                minWidth: 48,
                                backgroundPosition: 'center',
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat'
                            }} />
                        </div>
                        <ul className="list-unstyled align-self-center m-0 ml-2">
                            <li className="text-dark font-weight-bold" >
                                <div className="d-inline-block text-break" >{team && team.title}</div>
                            </li>

                            <li className="text-secondary small" >
                                <FontAwesomeIcon className="mr-1 text-third" icon={faUserTag} />
                                {team && (team.contact || '-')}
                            </li>
                        </ul>
                    </div>
                </div>
                :
                <div className="col p-2 m-0 ">
                    <TeamLoader />
                </div>
            }

            <div className="col-12 text-decoration-none p-0 mb-2 ">
                <nav className="small">
                    <div className="rounded-lg nav nav-tabs nav-fill flex-row font-weight-bold" id="nav-tab" role="tablist">

                        <a className={"border border-white bg-bluegray nav-item nav-link text-dark active" + disabled} id="nav-players-tab" data-toggle="tab" href="#nav-players" role="tab" aria-controls="nav-players" aria-selected="true">
                            Plantilla
                            </a>

                        <a className={"border border-white bg-bluegray nav-item nav-link text-dark " + disabled} id="nav-general-tab" data-toggle="tab" href="#nav-general" role="tab" aria-controls="nav-general" aria-selected="false">
                            General
                            </a>

                    </div>
                </nav>

                <div className="tab-content p-2" id="nav-tabContent">

                    <div className="tab-pane fade show active" id="nav-players" role="tabpanel" aria-labelledby="nav-players-tab">
                        <PlayerList loading={loadingPlayers && loadingTeam} team={team} players={players} />
                    </div>
                    <div className="tab-pane fade" id="nav-general" role="tabpanel" aria-labelledby="nav-general-tab">
                        <TeamGeneral loading={loadingTeam} team={team} />
                    </div>

                </div>

            </div>

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />


        </div >
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(TeamPage);